import { FC, useMemo } from 'react';
import { mapStore } from '../../../Map3d/map.store';
import { formatCardsDate } from '../../../../helpers/formatCardsDate';
import { RealEstateCardProps } from '../realEstateCard.types';
import './style.scss';

const priceFallback = '153 - 342 FTN';

const RealEstateCardView: FC<RealEstateCardProps> = ({ room, index }) => {
  const customDataMapping = useMemo(() => {
    if (!room.isCustom) {
      return null;
    }

    return {
      priceText: room.price
        ? `${room.price.amount} ${room.price.currency}`
        : '',
      date: `${room.startDate} - ${room.endDate}`,
      details: room.details?.map((item) => {
        return (
          <div key={item.id} className="realEstateDesc">
            <span className="realEstateDescTitle">{item.title}: </span>
            <span className="realEstateAddInfo">{item.value}</span>
          </div>
        );
      }),
    };
  }, [room]);

  return (
    <div className="realEstateCardContent">
      <div>
        <h2 className="realEstateCardTitle">{room?.name}</h2>
        {room.startDate || room.endDate || room.address?.name || room.location ? (
          <>

            <span className="realEstateLocation">{room.address?.name}</span>
            {room.startDate && room.endDate && (
              <p className="realEstateDate">
                <i className="icon-calendar2" />
                {customDataMapping?.date || (
                  <>
                    {formatCardsDate(room.startDate)} -{' '}
                    {formatCardsDate(room.endDate)}
                  </>
                )}
              </p>
            )}

            {room.location && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  mapStore.searchInMap([
                    [room.location.latitude, room.location.longitude],
                  ]);
                }}
                className="hotelOnMap"
              >
                Show on map
              </span>
            )}
          </>
        ) : null}
      </div>

      <div className="realEstateCardCellWrapper">
        {customDataMapping?.priceText && (
          <div className="realEstateCardCell">
            <span className="realEstateCardCellInfo">{customDataMapping?.priceText}</span>
          </div>
        )}
        <div className="realEstateCardCell">
          <span className="realEstateCardCellInfo">37 - 105m²</span>
        </div>
        <div className="realEstateCardCell">
          <span className="realEstateCardCellInfo">2 - 5 Rooms</span>
        </div>
        <div className="realEstateCardCell">
          <span className="realEstateCardCellInfo">{room.numberOfUnits} units</span>
        </div>
      </div>
    </div>
  );
};

export default RealEstateCardView;
